const truthyPattern = /^(1|true|yes|on)$/i;

export const parseBooleanFlag = (value: string | undefined, defaultValue: boolean): boolean => {
  if (value === undefined) {
    return defaultValue;
  }

  const trimmed = value.trim();
  if (trimmed === '') {
    return defaultValue;
  }

  if (truthyPattern.test(trimmed)) {
    return true;
  }

  if (/^(0|false|no|off)$/i.test(trimmed)) {
    return false;
  }

  return defaultValue;
};

export const flags = {
  congregationMentorStage0: parseBooleanFlag(
    process.env.REACT_APP_FLAG_CONGREGATION_MENTOR_STAGE_0,
    true,
  ),
  congregationMentorNotifications: parseBooleanFlag(
    process.env.REACT_APP_FLAG_CONGREGATION_MENTOR_NOTIFICATIONS,
    false,
  ),
  congregationMentorAuditLog: parseBooleanFlag(
    process.env.REACT_APP_FLAG_CONGREGATION_MENTOR_AUDIT_LOG,
    false,
  ),
};

export type Flags = typeof flags;

